import React, { useEffect, useRef, useState } from "react";
import "./scoreRating.style.scss";
import {
  __ScoreRatingProps,
  __ScoreRatingRef,
  __ScoreRatingIcon,
} from "./scoreRating.interface";
import { TextDirection } from "interface";
import HintText from "../hintText/hintText.index";
import QuestionImage from "../questionImage/questionImage.index";
import { extractTitle } from "scripts/string";
export interface SLPScoreRatingRef extends __ScoreRatingRef {}
export { __ScoreRatingIcon as ScoreRatingIcon };

const SLPScoreRating: React.ForwardRefRenderFunction<
  __ScoreRatingRef,
  __ScoreRatingProps
> = (props: __ScoreRatingProps, ref) => {
  const [value, setValue] = useState<number | null>(
    props.defaultValue ? props.defaultValue : null
  );
  const immediateValue = useRef<number | null>(value);
  const [hover, setHover] = useState<number | null>(null);
  const [error, setError] = useState<string>();
  const labelRef = useRef<HTMLLabelElement>(null);

  React.useImperativeHandle(ref, () => ({
    getValue: () => immediateValue.current,
    getValidation: () => (props.required === true ? value !== null : true),
    setError: (text) => {
      setError(text);
    },
  }));

  useEffect(() => {
    if (labelRef.current && props.label)
      labelRef.current.innerHTML = extractTitle(props.label, false);
  }, [props.label]);

  const changeHandler = (e: number) => {
    setError(undefined);
    immediateValue.current = e;
    setValue(immediateValue.current);
    if (props.onChange) props.onChange(e);
  };

  function condition(index: number) {
    return Number(value) >= index + 1 || Number(hover) >= index + 1;
  }

  return (
    <div
      className={`ucheck-SLP-score-rating  ${
        props.dir === TextDirection.rtl ? "rtl-text" : ""
      }`}
    >
      <div className="score-rating-header">
        {props.required && <span className="required-star">*</span>}
        <span className="counter-span">
          {props.counter ? props.counter + "- " : ""}
        </span>
        <label ref={labelRef} style={{ color: props.labelColor }} />
      </div>
      <QuestionImage src={props.image?.file} />
      <HintText value={props.hint} />
      <div className="score-rating-container">
        {Array.from(Array(10).keys()).map((item, index) => (
          <span
            onMouseEnter={() => setHover(index + 1)}
            onMouseLeave={() => setHover(null)}
            key={index}
            onClick={() => changeHandler(index + 1)}
            className={`material-icons${condition(index) ? "" : "-outlined"} ${
              props.max && props.max < index + 1 ? "disable d-none" : ""
            }`}
            style={{ color: props.color }}
          >
            {props.icon === __ScoreRatingIcon.circle && (
              <>{condition(index) ? "stop_circle" : "lens"}</>
            )}
            {props.icon === __ScoreRatingIcon.heart && (
              <>{condition(index) ? "favorite" : "favorite_border"}</>
            )}
            {props.icon === __ScoreRatingIcon.star && (
              <>{condition(index) ? "star_rate" : "star_outline"}</>
            )}
            {props.icon === __ScoreRatingIcon.person && <>person</>}
            {props.icon === __ScoreRatingIcon.thumb_up && <>thumb_up</>}
            {props.icon === __ScoreRatingIcon.flag && <>flag</>}
          </span>
        ))}
      </div>
      {error && <p className="rate-error">{error}</p>}
    </div>
  );
};

export default React.forwardRef(SLPScoreRating);
